import { defaultUserState } from './module-user-state';
import { ModuleMws } from '../module-const';

export default {
	resetState(state) {
		Object.assign(state, defaultUserState);
	},
	updateUserList(state, res) {
		state.UserList.removeAll();
		state.UserList.append(res.Data.Data);
		state.Total = res.Data.Total;
	},
	deleteUser(state, item) {
		state.UserList.remove(item);
		state.Total -= 1;
	},
	addNew(state, item) {
		state.UserList.push(item);
		state.Total += 1;
	},
	updateUserListLoaded(state, data) {
		state.userListLoaded = data;
	},
	/**
	 * Cập nhật bản ghi UserTax hiện tại (theo MisaId + TaxCode) được trả về lúc login/đổi MST
	 * Dùng cho getter kiểm tra AmisConvertStatus của user đang đăng nhập không phụ thuộc UserList
	 */
	setCurrentUserTax(state, userTax) {
		// Đổi MST làm việc → clear cache token MWS (token gắn theo TaxCode)
		this.dispatch(`${ModuleMws}/clearMWSToken`);
		state.currentUserTax = userTax;
	},
	updateAmisConvertStatus(state, payload) {
		const userTax = state.UserList.find(
			item =>
				item.MisaId == payload.MisaId && item.TaxCode == payload.TaxCode
		);
		if (userTax) {
			userTax.AmisConvertStatus = payload.AmisConvertStatus;
		}

		// Đồng bộ trạng thái đã xem sang currentUserTax nếu trùng khóa
		if (
			state.currentUserTax &&
			state.currentUserTax.MisaId == payload.MisaId &&
			state.currentUserTax.TaxCode == payload.TaxCode
		) {
			state.currentUserTax.AmisConvertStatus = payload.AmisConvertStatus;
		}
	}
};
